/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIUserAutocompleteSuggestion
 */
export interface APIUserAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIUserAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIUserAutocompleteSuggestion
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof APIUserAutocompleteSuggestion
     */
    fullName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIUserAutocompleteSuggestion
     */
    roleNames: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIUserAutocompleteSuggestion
     */
    rootAccountName: string;
}

/**
 * Check if a given object implements the APIUserAutocompleteSuggestion interface.
 */
export function instanceOfAPIUserAutocompleteSuggestion(value: object): value is APIUserAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('roleNames' in value) || value['roleNames'] === undefined) return false;
    if (!('rootAccountName' in value) || value['rootAccountName'] === undefined) return false;
    return true;
}

export function APIUserAutocompleteSuggestionFromJSON(json: any): APIUserAutocompleteSuggestion {
    return APIUserAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIUserAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIUserAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'fullName': json['full_name'],
        'roleNames': json['role_names'],
        'rootAccountName': json['root_account_name'],
    };
}

export function APIUserAutocompleteSuggestionToJSON(value?: APIUserAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'email': value['email'],
        'full_name': value['fullName'],
        'role_names': value['roleNames'],
        'root_account_name': value['rootAccountName'],
    };
}

